// File: frontend/src/pages/InvestorPitch/components/slides/AllegoryDescriptionSlide/AllegoryDescriptionSlide.js

import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { ANIMATION_VARIANTS } from '../../../constants/animations';
import styles from './AllegoryDescriptionSlide.module.css';

const AllegoryDescriptionSlide = () => {
  const { t } = useLanguage();

  const capabilities = [
    { 
      id: 'ai_agents',
      icon: '🤖'
    },
    { 
      id: 'core_system',
      icon: '🏢'
    },
    { 
      id: 'omnichannel',
      icon: '📱'
    },
    { 
        id: 'embedded',
        icon: '🔌'
    },
    { 
        id: 'infrastructure',
        icon: '☁️'
    },
    { 
      id: 'languages',
      icon: '🌐'
    },
  ];

  return (
    <motion.div
      className={styles.container}
      variants={ANIMATION_VARIANTS.stagger.container}
      initial="hidden"
      animate="visible"
    >
      <motion.div 
        className={styles.header}
        variants={ANIMATION_VARIANTS.fadeIn}
      >
        <h2 className={styles.title}>
          {t('investor_pitch.allegory_description.title')}
        </h2>
        {/* <p className={styles.subtitle}>
          {t('investor_pitch.allegory_description.subtitle')}
        </p> */}
      </motion.div>

      <motion.div 
        className={styles.capabilitiesGrid}
        variants={ANIMATION_VARIANTS.stagger.container}
      >
        {capabilities.map((capability, index) => (
          <motion.div
            key={capability.id}
            className={styles.capabilityCard}
            variants={ANIMATION_VARIANTS.stagger.item}
            custom={index}
          >
            <div className={styles.capabilityHeader}>
              <div className={styles.capabilityIcon}>{capability.icon}</div>
              <h3 className={styles.capabilityTitle}>
                {t(`investor_pitch.allegory_description.capabilities.${capability.id}.title`)}
              </h3>
            </div>
            <p className={styles.capabilityDescription}>
              {t(`investor_pitch.allegory_description.capabilities.${capability.id}.description`)}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default AllegoryDescriptionSlide;